<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-container fluid>
            <v-form  ref="searchUserForm" @submit.prevent="getUsers">
                <v-card flat>
                    <v-container fluid>
                        <v-layout>
                            <v-flex md3>
                                <v-select :items="organizations"
                                          label="Filter By Organization"
                                          item-text="name"
                                          v-model="filter.organization"
                                          item-value="id">
                                </v-select>
                            </v-flex>
                            <v-flex md3>
                                <v-text-field type="text"
                                              label="Filter By Last Name"
                                              v-model="filter.lastName"></v-text-field>
                            </v-flex>
                            <v-flex md3>
                                <v-text-field type="text"
                                              label="Filter By First Name"
                                              v-model="filter.firstName"></v-text-field>
                            </v-flex>
                            <v-flex md3>
                                <v-select :items="statuses"
                                          label="Filter By Status"
                                          item-text="name"
                                          v-model="filter.status"
                                          item-value="id"></v-select>
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex md3>
                                <v-text-field type="text"
                                              label="Filter By E-Mail"
                                              v-model="filter.email"></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-container>
                    <v-card-actions>
                        <v-btn outlined type="submit" @click="getUsers()" color="success">
                            Search
                            <v-icon right dark>mdi-magnify-plus-outline</v-icon>
                        </v-btn>
                        <v-btn outlined @click="resetFilter()" color="warning">
                            Reset
                            <v-icon right dark>mdi-autorenew</v-icon>
                        </v-btn>
                        <v-btn outlined @click="addUser()" color="primary">
                            Create User
                            <v-icon right dark>mdi-plus-circle-outline</v-icon>
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
            <v-divider></v-divider>
            <v-data-table
                    :headers="headers"
                    :items="users"
                    :options.sync="pagination"
                    :loading="loading"
                    :server-items-length="totalRecords"
                    class="elevation-1">
                <template v-slot:item.organizationNames="{item}">
                    <div v-for="org in item.organizationNames">
                        {{org}}
                    </div>
                </template>
                <template v-slot:item.phoneNumber="{item}">
                    {{$firstAlertUtils.formatPhone(item.phoneNumber)}}
                </template>
                <template v-slot:item.status="{item}">
                    {{item.status == 'A' ? 'Active' : 'Inactive'}}
                </template>
                <template v-slot:item.actions="{item}">
                    <v-btn icon v-if="$permissionHolder.hasPermission('USER.UPDATE')"
                           v-on:click="editUser(item.id)">
                        <v-icon dark>mdi-pencil</v-icon>
                    </v-btn>
                </template>
            </v-data-table>
        </v-container>
    </div>
</template>

<script>

    import api from '@/api';


    export default {
        data() {
            return {
                headers: [
                    {text: 'E-Mail', value: 'email'},
                    {text: 'First Name', value: 'firstName'},
                    {text: 'Middle Name', value: 'middleName'},
                    {text: 'Last Name', value: 'lastName'},
				    {text: 'Phone', value: 'phoneNumber'},
                    {text: 'Organization(s)', value: 'organizationNames', sortable: false},
                    {text: 'Status', value: 'status'},
                    {text: 'Actions', value: 'actions'}
                ],
                pagination: {
                   // rowsPerPage: 25,
                    //pageNumber: 1
                },
                users: [],
                organizations: [],
                totalRecords: 0,
                statuses: [
                    {id: '', name: 'All'},
                    {id: 'A', name: 'Active'},
                    {id: 'I', name: 'Inactive'}
                ],
                loading:false,
                filter: {
                    organization: null,
                    status: null,
                    firstName: null,
                    lastName: null,
                    email: null
                }
            }
        },
        created() {
            api.organization.search().then(r => this.organizations = r.list);
        },
        watch: {
            pagination: {
                handler() {
                    this.getUsers();
                },
                deep: true
            }
        },
        methods: {
		    formatPhone: function(phoneNumber) {
                if (phoneNumber && phoneNumber != '') {
                    let p = String(phoneNumber.replaceAll(/[^0-9]/g,''));
                    if (p.length == 10) {
                        return "("+p.substring(0,3)+") "+p.substring(3,6)+"-"+p.substring(6);
				    } else {
                        return p;
                    }
                } else {
                    return phoneNumber;
                }
		    },
            addUser: function () {
                this.$router.push({name: 'CreateUser'});
            },
            editUser: function (userId) {
                this.$router.push({'path': '/user/' + userId});
            },
            resetFilter: function () {
                this.filter = {};
                this.getUsers();
            },
            getUsers: function () {
                const that = this;
                that.loading = true;
                return new Promise((resolve, reject) => {
                    const sortDesc = !!this.pagination.sortDesc[0];
                    const sortOrder = sortDesc ? 'DESC' : 'ASC';
                    api.user.search({
                        pageNumber: this.pagination.page - 1,
                        rowsPerPage: this.pagination.itemsPerPage,
                        sortBy: this.pagination.sortBy,
                        sortOrder: sortOrder,
                        organizationIds: this.filter.organization ? [this.filter.organization] : null,
                        firstName: this.filter.firstName,
                        lastName: this.filter.lastName,
                        status: this.filter.status,
                        email: this.filter.email
                    }).then(response => {
                        that.users = response.list;
                        that.totalRecords = response.totalRecords;
                        resolve();
                    }).catch(error => {
                        reject();
                    }).finally(() => {
                        that.loading = false;
                    });
                });
            }
        }
    }
</script>